import React from 'react';
import { createPortal } from 'react-dom';
import './LogHoursReminderModal.css';

interface LogHoursReminderModalProps {
  personName: string;
  onClose: () => void;
}

export const LogHoursReminderModal: React.FC<LogHoursReminderModalProps> = ({
  personName,
  onClose,
}) =>
{
  return createPortal(
    <div
      className="log-hours-reminder-dialog"
      id="ReminderLogHoursDialogId"
    >
      <button className="log-hours-reminder-close" onClick={onClose} aria-label="Close">
        <span className="material-icons" style={{ fontSize: '18px' }}>close</span>
      </button>

      <div className="log-hours-reminder-body">
        <img
          className="log-hours-reminder-dog"
          src="/Images/corgee-dog-circle.png"
          alt="Corgee"
        />

        <div className="log-hours-reminder-title-row">
          <span className="material-icons log-hours-reminder-bell">notifications</span>
          <p className="log-hours-reminder-title">Corgee Reminder!</p>
        </div>

        <p className="log-hours-reminder-name">Dear {personName},</p>
        <p className="log-hours-reminder-text">remember to log in your time worked today.</p>
      </div>

      <div className="log-hours-reminder-footer">
        <button className="log-hours-reminder-btn" onClick={onClose}>
          Close
        </button>
      </div>
    </div>,
    document.body,
  );
};
